export default __webpack_public_path__ + "static/media/115.dc80c9cb.jpg";